import * as React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';

function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant="standard" {...props} />;
}

interface IProps {

}

interface IState {
    isOpen: boolean,
    summary: string,
    severity: "info" | "success" | "warning" | "error"
}

class SnackbarComponent extends React.Component<IProps, IState> {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            summary: '',
            severity: 'info'
        }
    }

    show(value) {
        this.setState({ isOpen: true, summary: value.summary, severity: value.severity });
    }

    handleClose = () => {
        this.setState({ isOpen: false });
    }
    // type: success, warning, error, info
    render() {
        return (
            <Snackbar
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                open={this.state.isOpen}
                autoHideDuration={this.state.summary ? this.state.summary.length * 70 + 1000 : 4000}
                onClose={this.handleClose}
            >
                <Alert onClose={this.handleClose} severity={this.state.severity}>{this.state.summary}</Alert>
            </Snackbar>
        )
    }
}

export default SnackbarComponent;